import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.bf{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.gs{justify-content:stretch;}.ssr-plugin'
import '.ar{position:sticky;}.ssr-plugin'
import '.as{top:0px;}.ssr-plugin'
import '.ay{z-index:10;}.ssr-plugin'
import '.g8{padding-block:1rem;}.ssr-plugin'
import '.g9{height:3rem;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.gu{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fr{margin-top:2rem;}.ssr-plugin'
import '.ge{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const CreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d r ax e dj"
      >
        <div className="bf d t ax e"
        >
          <div className="n ab d e gs ar as ay"
            style={{
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            <nav className="g8 g9 d ae t ah"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gu d e r fr ge n ab"
            style={{
              gap: gap, // 8rem is padding + navbar height
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
